import script from "./UOnWorkplace.vue?vue&type=script&setup=true&lang=ts"
export * from "./UOnWorkplace.vue?vue&type=script&setup=true&lang=ts"

import "./UOnWorkplace.vue?vue&type=style&index=0&id=a908616e&lang=css"

const __exports__ = script;

export default __exports__